import _ from 'lodash';
import { QueryString } from '~/utils';
import { get, post, del } from './agent';

const creditNoteFiles =
  (creditNoteFilesUrl) =>
  (id = '') => {
    const url = _([creditNoteFilesUrl, id]).compact().join('/');

    return {
      get: (query = {}) => get(url.concat(new QueryString(query).toString(true))),
      getFilesSize: () => get(url.concat('/files-size')),
      upload: (body) => post(url, body),
      delete: () => del(url),
    };
  };

export default creditNoteFiles;
